import { jsx as _jsx, jsxs as _jsxs } from "react/jsx-runtime";
// Review archetype — summary card + complete-draft submit. Behavior
// ported from apps/portal/src/signup/steps/ReviewStep.tsx. The
// completion handler is host-supplied via `adapters.completeDraft`;
// when it returns, the host should swap the stage out for a Completed
// archetype render.
import { useState } from 'react';
export function ReviewComponent(props) {
    const { payload, adapters, back } = props;
    const [busy, setBusy] = useState(false);
    const [error, setError] = useState(null);
    const contact = payload.contact ?? {};
    const address = payload.serviceAddress;
    const planId = payload.planId;
    const billing = payload.billing;
    async function onComplete() {
        if (!adapters.completeDraft) {
            setError('Completion handler not wired by the host.');
            return;
        }
        setBusy(true);
        setError(null);
        try {
            await adapters.completeDraft();
            // Host owns the post-complete redirect via the completeDraft return value.
        }
        catch (e) {
            setError(e instanceof Error ? e.message : String(e));
        }
        finally {
            setBusy(false);
        }
    }
    return (_jsxs("div", { className: "flex flex-col gap-4", children: [_jsx("h3", { className: "m-0 text-lg font-semibold", children: "Review & submit" }), _jsx("p", { className: "m-0 text-sm text-[var(--bcbb-text-muted)]", children: "One last check before we create your account." }), _jsxs("dl", { className: "grid grid-cols-1 gap-4 rounded-md bg-[var(--bcbb-surface-2)] p-4 md:grid-cols-2", children: [_jsx(Pair, { label: "Name", value: `${contact.firstName ?? ''} ${contact.lastName ?? ''}`.trim() || '—' }), _jsx(Pair, { label: "Email", value: contact.email ?? '—' }), _jsx(Pair, { label: "Phone", value: contact.phone ?? '—' }), _jsx(Pair, { label: "Service address", value: address
                            ? `${address.line1}${address.line2 ? `, ${address.line2}` : ''}, ${address.city}, ${address.state} ${address.postalCode}`
                            : '—' }), _jsx(Pair, { label: "Plan", value: planId ?? '—' }), _jsx(Pair, { label: "Payment method", value: billing?.stripePmId ? `Saved (${billing.stripePmId.slice(0, 14)}…)` : '—' })] }), error && (_jsx("div", { className: "rounded-md bg-[var(--bcbb-danger-bg,#fde0df)] px-3 py-2 text-sm text-[var(--bcbb-danger)]", children: error })), _jsxs("div", { className: "mt-4 flex items-center justify-between gap-3", children: [_jsx("button", { type: "button", onClick: back, disabled: busy, className: "rounded-md border bg-white px-4 py-2 text-sm font-medium", style: { borderColor: 'var(--bcbb-border)' }, children: "Back" }), _jsx("button", { type: "button", onClick: onComplete, disabled: busy, className: "rounded-md px-5 py-3 text-base font-semibold text-white disabled:opacity-60", style: { background: 'var(--bcbb-primary)' }, children: busy ? 'Creating your account…' : 'Create my account' })] })] }));
}
function Pair({ label, value }) {
    return (_jsxs("div", { children: [_jsx("dt", { className: "text-xs font-semibold uppercase tracking-wide text-[var(--bcbb-text-muted)]", children: label }), _jsx("dd", { className: "m-0 mt-1 text-sm", children: value })] }));
}
export const ReviewArchetype = {
    name: 'Review',
    label: 'Review & submit',
    description: 'Summary card + complete-draft submit.',
    component: ReviewComponent,
    isFormArchetype: false,
    fields: {},
    defaultConfig: {},
};
